import HealthcareSiteActivityContainer from './healthcare-site-activity-container';

export default HealthcareSiteActivityContainer;
